import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import api from "@/lib/api";

function formatDetail(detail) {
  if (!detail) return "Login failed. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.token) window.localStorage.setItem("stj_admin_token", data.token);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="blueprint-dark flex min-h-screen items-center justify-center bg-ink px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-white/10 bg-navy/60 p-8 backdrop-blur sm:p-10">
        <Logo light />
        <h1 className="mt-8 font-display text-2xl font-semibold text-white">Admin Portal</h1>
        <p className="mt-2 text-sm text-slate-400">Sign in to manage products, content and enquiries.</p>
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label htmlFor="al-email" className="label-field !text-slate-400">Email</label>
            <input id="al-email" data-testid="admin-email-input" type="email" required autoComplete="email"
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="input-field !border-white/15 !bg-ink !text-white" />
          </div>
          <div>
            <label htmlFor="al-password" className="label-field !text-slate-400">Password</label>
            <input id="al-password" data-testid="admin-password-input" type="password" required autoComplete="current-password"
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="input-field !border-white/15 !bg-ink !text-white" />
          </div>
          <button type="submit" data-testid="admin-login-submit" disabled={loading}
            className="w-full bg-accent py-3.5 text-sm font-semibold text-white transition-colors hover:bg-accent-dark disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <a href="/" data-testid="admin-back-to-site" className="mt-6 block text-center font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500 hover:text-white">
          ← Back to website
        </a>
      </div>
    </div>
  );
}
